module.exports = __webpack_public_path__ + "static/adelle_italic-webfont-woff-0482e8705e4787f991c21549e91876ba.woff";